import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SecondaryButton } from 'common/components';
import { ReactComponent as CloseIcon } from 'applicaiton/assets/close.svg';
import { ReactComponent as SuccesslIcon } from 'applicaiton/assets/success-icon.svg';
import { StyledModal } from './styles';

interface SuccessModalProps {
  onClose: () => void;
}

const SuccessModal: FC<SuccessModalProps> = ({ onClose }) => {
  const { t } = useTranslation();
  return (
    <StyledModal>
      <CloseIcon onClick={onClose} />
      <div>
        <SuccesslIcon />
        <p>{t('patient_edit_form.success_updated')}</p>
        <SecondaryButton onClick={onClose}>
          {t('appointment_types.modal_success.ok')}
        </SecondaryButton>
      </div>
    </StyledModal>
  );
};

export default SuccessModal;
